// extracted by mini-css-extract-plugin
export default {"base":"base__index__THfon","scroll":"scroll__index__fSl4e"};